import * as Yup from 'yup'
import { suggestive } from 'yup-locale-ja'
Yup.setLocale(suggestive)
